<template>
  <router-link class="d-flex justify-center no-underline inherit-color"
               :to="{name: 'patientResources@find', params: {resource_id: media.id}}">
    <MediaCard :media="media"></MediaCard>
    <p style="display:none">{{mediaId}}</p>
  </router-link>
</template>

<script>
  import api from 'api'
  import MediaCard from "../MediaCard";

  export default {
    components: {MediaCard},
    data() {
      return {
        media: {}
      }
    },

    props: {
      mediaId: {
        required: true
      }
    },

    mounted() {
      api.get(`applicationMedias/${this.mediaId}`)
        .then(res => {
          this.media = res.data
        })
    }
  }
</script>
